import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { heartDiseaseBase } from "../../../enum/enums";

const BaseHeartDiseaseCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        baseHeartDiseaseListParm,
        ...attributes
    } = props;

    const [baseHeartDiseaseList, setBaseHeartDiseaseList] = useState(baseHeartDiseaseListParm);
    const [type, setType] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setBaseHeartDiseaseList(baseHeartDiseaseListParm);
    }, [baseHeartDiseaseListParm]);

    function handleAddBaseHeartDisease() {
        if (!isEditing) {
            const newBaseHeartDiseaseItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                month,
                year
            };

            const newBaseHeartDiseaseList = [...baseHeartDiseaseList, newBaseHeartDiseaseItem];
            setBaseHeartDiseaseList(newBaseHeartDiseaseList);
            onRequestAdd(newBaseHeartDiseaseList);
        } else {
            const newBaseHeartDiseaseList = baseHeartDiseaseList.map(baseHeartDiseaseItem => {
                if (baseHeartDiseaseItem.id === idRowEditing) {
                    return {
                        id: baseHeartDiseaseItem.id,
                        type,
                        month,
                        year
                    }
                }

                return baseHeartDiseaseItem;
            })
            setBaseHeartDiseaseList(newBaseHeartDiseaseList);
            onRequestAdd(newBaseHeartDiseaseList);
        }

        resetFields();
    }

    function handleEditBaseHeartDisease(id) {
        const editRowInfo = baseHeartDiseaseList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setMonth(editRowInfo.month);
            setYear(editRowInfo.year);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeleteBaseHeartDisease(id) {
        const newBaseHeartDiseaseList = baseHeartDiseaseList.filter(x => x.id !== id);
        setBaseHeartDiseaseList(newBaseHeartDiseaseList);
        onRequestAdd(newBaseHeartDiseaseList);
    }

    function resetFields() {
        setType(null);
        setMonth("");
        setYear("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Cardiopatia de Base</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-6">
                                <label><small>Cardiopatia Base</small></label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={heartDiseaseBase}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Mês</small></label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={month}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 2) return false;
                                        setMonth(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Ano</small></label>
                                <InputMask
                                    mask="9999"
                                    maskChar=" "
                                    value={year}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 4) return false;
                                        setYear(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddBaseHeartDisease}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={baseHeartDiseaseList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Cardiopatia</strong>
                                            </th>
                                            <th>
                                                <strong>Mês</strong>
                                            </th>
                                            <th>
                                                <strong>Ano</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            baseHeartDiseaseList.map((baseHeartDiseaseItem) => {
                                                return (
                                                    <tr key={baseHeartDiseaseItem.id}>
                                                        <td>{baseHeartDiseaseItem.type.label}</td>
                                                        <td>{baseHeartDiseaseItem.month}</td>
                                                        <td>{baseHeartDiseaseItem.year}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditBaseHeartDisease(baseHeartDiseaseItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeleteBaseHeartDisease(baseHeartDiseaseItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

BaseHeartDiseaseCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

BaseHeartDiseaseCard.defaultProps = {
    baseHeartDiseaseListParm: []
};

export default BaseHeartDiseaseCard;